import { Button, Input } from "components"
import { Box } from "theme-ui"
import selectIcon from "./selecticon.png"
import { useTranslation } from "react-i18next"
export const DesiredSwitchSystem = () => {
             // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   Heading: "TestanlageCopy 01",
   items: [
    { info1: "TestanlageCopy 01" },
    { info2: "TestanlageCopy 01" },
    { info3: "TestanlageCopy 01" },
    { info4: "TestanlageCopy 01" },
    { info5: "TestanlageCopy 01" },
    { info6: "TestanlageCopy 01" },
    { info7: "TestanlageCopy 01" },
    { info8: "TestanlageCopy 01" },
   ],
  },
  {
   Heading: "Name",
   items: [
    { info1: "Engersche Straße / Johannisbach" },
    { info2: "Engersche Straße / Johannisbach" },
    { info3: "Engersche Straße / Johannisbach" },
    { info4: "Engersche Straße / Johannisbach" },
    { info5: "Engersche Straße / Johannisbach" },
    { info6: "Engersche Straße / Johannisbach" },
    { info7: "Engersche Straße / Johannisbach" },
    { info8: "Engersche Straße / Johannisbach" },
   ],
  },
 ]

 return (
  <div className="w-[96%] mx-auto">
   <h1 className="font-semibold Jakarta-font pt-6 pb-4">{t("switchSystems")}</h1>
   <Box bg="highlight" color="text-black" className="px-4">
    <h1 className="font-semibold Jakarta-font py-4">{t("desiredSwitchingProcess")}</h1>
    <div className="flex justify-between ">
     <div className="flex flex-col justify-center w-[30%]">
      <Input
       label={t("beginning")}
       id="begin"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="date"
      />
     </div>
     <div className="flex flex-col justify-center w-[30%]">
      <Input
       label={("end")}
       id="end"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="date"
      />
     </div>
     <div className="flex flex-col justify-center w-[38%]">
      <Input
       label={t("plantCondition")}
       id="text"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="text"
       placeholder="Enter here..."
      />
     </div>
    </div>
    <div className="flex justify-between pt-2">
     <div className="flex flex-col justify-center w-[38%]">
      <Input
       label={t("signalProgram")}
       id="Signalprogramm:"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="text"
       placeholder="Enter here..."
      />
     </div>
     <div className="flex flex-col justify-center w-[20%]">
      <Input
       label="VA"
       id=" VA"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="text"
       placeholder="Lokal"
      />
     </div>
     <div className="flex flex-col justify-center w-[20%]">
      <Input
       label={t("publicTransport")}
       id="ÖPNV:"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="text"
       placeholder="Lokal"
      />
     </div>
     <div className="flex flex-col justify-center w-[20%]">
      <Input
       label="IV"
       id="IV"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="text"
       placeholder="Lokal"
      />
     </div>
    </div>

    <div className="flex flex-col justify-center w-full pt-2">
     <Input
      label={t("remarks")}
      id="Bemerkung"
      className="bg-gray py-2 outline-none rounded px-2 text-black"
      type="email"
      placeholder="muddassarhaseeb34@gmail.com"
     />
    </div>
    <div className="flex justify-end py-4">
     <div className="w-full-">
      <Button size={"xl"}>{t("carryOut")} </Button>
     </div>
    </div>
   </Box>
   <Box bg="highlight">
    <div className="mt-6">
     <div className="flex justify-between w-[96%] mx-auto items-center pt-4">
      <h1 className="pb-2 font-semibold">Forum Gera: STm.5 Forum Gera</h1>
      <div className="bg-dark-yellow h-6 w-6 rounded border-yellow border flex justify-center items-center">
       <img src={selectIcon} alt="selectIcon" loading="lazy" />
      </div>
     </div>

     <div className="px-4 flex w-full">
      {data.map((single, index) => (
       <div key={index} className="w-[50%]">
        <h1 className="pl-2 font-semibold">{single.Heading}</h1>
        {single.items.map((item, itemIndex) => (
         <div
          key={itemIndex}
          className="border-t-[1px] border-r-[1px] border-gray py-2 w-full pl-2"
         >
          <h1>{item.info1}</h1>
          <h1>{item.info2}</h1>
          <h1>{item.info3}</h1>
          <h1>{item.info4}</h1>
          <h1>{item.info5}</h1>
          <h1>{item.info6}</h1>
          <h1>{item.info7}</h1>
          <h1>{item.info8}</h1>
         </div>
        ))}
       </div>
      ))}
     </div>
    </div>
   </Box>
  </div>
 )
}
